module.exports = __webpack_public_path__ + "img/portfolio_comming_soon.abe2a020.png";